/**
 * 등락률 계산 유틸리티
 */
/**
 * 등락률을 계산합니다
 * @param currentPrice - 현재가
 * @param closePrice - 전일 종가
 * @returns 등락률 (백분율), 전일종가가 0이거나 유효하지 않으면 NaN
 */
export function calculateChangeRate(currentPrice, closePrice) {
    // 유효성 검증
    if (typeof currentPrice !== 'number' ||
        isNaN(currentPrice) ||
        typeof closePrice !== 'number' ||
        isNaN(closePrice) ||
        closePrice <= 0) {
        return NaN;
    }
    return ((currentPrice - closePrice) / closePrice) * 100;
}
/**
 * 등락률과 등락액을 함께 계산합니다
 * @param currentPrice - 현재가
 * @param closePrice - 전일 종가
 * @returns 등락률과 등락액 객체
 */
export function calculateChangeRateAndAmount(currentPrice, closePrice) {
    const changeRate = calculateChangeRate(currentPrice, closePrice);
    const changeAmount = calculateChangeAmount(currentPrice, closePrice);
    return { changeRate, changeAmount };
}
/**
 * 등락폭을 계산합니다
 * @param currentPrice - 현재가
 * @param closePrice - 전일 종가
 * @returns 등락폭
 */
export function calculateChangeAmount(currentPrice, closePrice) {
    return currentPrice - closePrice;
}
/**
 * 가격 변동 정보를 계산합니다
 * @param currentPrice - 현재가
 * @param closePrice - 전일 종가
 * @returns 등락폭, 등락률, 방향 정보
 */
export function calculatePriceChange(currentPrice, closePrice) {
    const changeAmount = calculateChangeAmount(currentPrice, closePrice);
    const changeRate = calculateChangeRate(currentPrice, closePrice);
    let direction = 'unchanged';
    if (changeAmount > 0)
        direction = 'up';
    else if (changeAmount < 0)
        direction = 'down';
    return {
        changeAmount,
        changeRate,
        direction,
    };
}
/**
 * 등락률을 포맷팅합니다
 * @param changeRate - 등락률 (NaN이면 '-' 반환)
 * @param decimalPlaces - 소수점 자릿수 (기본: 2)
 * @returns 포맷팅된 문자열 (예: "+2.50%", "-1.23%", "0.00%", "-")
 */
export function formatChangeRate(changeRate, decimalPlaces = 2) {
    // NaN이거나 유효하지 않은 경우 '-' 반환
    if (typeof changeRate !== 'number' || isNaN(changeRate)) {
        return '-';
    }
    const formatted = changeRate.toFixed(decimalPlaces);
    const sign = changeRate > 0 ? '+' : '';
    return `${sign}${formatted}%`;
}
/**
 * 등락폭을 포맷팅합니다
 * @param changeAmount - 등락폭
 * @param decimalPlaces - 소수점 자릿수 (기본: 2)
 * @returns 포맷팅된 문자열 (예: "+1.50", "-0.75", "0.00")
 */
export function formatChangeAmount(changeAmount, decimalPlaces = 2) {
    const formatted = changeAmount.toFixed(decimalPlaces);
    // 소수점 둘째 자리까지 표시했을 때 0.00이면 기호 없이 표시
    if (formatted === '0.00') {
        return `0.00`;
    }
    const sign = changeAmount > 0 ? '+' : '';
    return `${sign}${formatted}`;
}
//# sourceMappingURL=priceChange.js.map